import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  Badge,
  Select,
  Stack,
  Flex,
} from "@chakra-ui/react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";
import StatusLogs from "components/Card/StatusLogs";

import { useDispatch, useSelector } from "react-redux";
import { fetchStatusHistoryAction } from "state/actions/statusHistoryActions";

const EditCashoutDrawer = ({
  cashout,
  isOpen,
  onClose,
  onUpdate,
}) => {
  const dispatch = useDispatch();

  const [status, setStatus] = useState("");
  const [status_reason, setReason] = useState("");

  const { history, loading } = useSelector(
    (state) => state.statusHistory
  );


  useEffect(() => {
    if (cashout) {
      setStatus(cashout.status);
    }
  }, [cashout]);


  useEffect(() => {
    if (cashout?.cashout_id) {
      dispatch(
        fetchStatusHistoryAction("cashout", cashout.cashout_id)
      );
    }
  }, [dispatch, cashout]);

  const handleSubmit = () => {
    onUpdate(cashout.cashout_id, { status, status_reason });
    onClose();
  };

  if (!cashout) return null;


  const statusColor = {
    Approved: "green",
    Pending: "yellow",
    Rejected: "red",
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<h2>Manage Cashout</h2>}
      bodyContent={
        <Box>
     
          <Text fontWeight="500" mb={1} fontSize="sm" color="#8D93A1">
            Current Status
          </Text>

          <Badge
            colorScheme={statusColor[status] || "gray"}
            mb={4}
            borderRadius="md"
          >
            {status}
          </Badge>

       
          <Text fontWeight="500" mb={1} fontSize="sm" color="#8D93A1">
            Update Status
          </Text>

          <Select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            mb={4}
          >
            <option value="Pending">Pending</option>
            <option value="Approved">Approved</option>
            <option value="Rejected">Rejected</option>
          </Select>


          <ReusableInput
            label="Reason for Status Change"
            placeholder="Provide a brief status_reason"
            value={status_reason}
            onChange={(e) => setReason(e.target.value)}
            type="textarea"
          />

          <Box mt={6}>
            <Text
              fontWeight="600"
              mb={3}
              fontSize="sm"
              color="#8D93A1"
            >
              Status History
            </Text>

            {loading ? (
              <Flex overflowX="auto" gap={4}>
                {[1, 2, 3].map((i) => (
                  <Box
                    key={i}
                    minW="260px"
                    p={4}
                    borderRadius="md"
                    bg="gray.50"
                  >
                    <Box h="10px" w="70%" bg="gray.200" mb={2} />
                    <Box h="10px" w="90%" bg="gray.200" mb={2} />
                    <Box h="10px" w="60%" bg="gray.200" mb={2} />
                  </Box>
                ))}
              </Flex>
            ) : (
              <StatusLogs logs={history} />
            )}
          </Box>
        </Box>
      }
      footerContent={
        <Stack direction="row" spacing={3} justifyContent="flex-end">
          <GradientButton
            onClick={onClose}
            width="120px"
            height="36px"
          >
            Cancel
          </GradientButton>

          <GradientButton
            onClick={handleSubmit}
            width="140px"
            height="36px"
          >
            Save
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default EditCashoutDrawer;